import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/pages/home.vue'
import privacyPage from "@/pages/privacy-page.vue";
import termsPage from "@/pages/terms-page.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/privacy-policy',
        name: 'privacyPolicy',
        component: privacyPage
    },
    {
        path: '/terms-of-use',
        name: 'terms-of-use',
        component: termsPage
    }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            }
        } else {
            return {
                top: 0,
                left: 0,
                behavior: 'smooth'
            }
        }
    }
})

export default router